/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberPolicyApprovalStatusOutputDto { 
    hasPolicy?: boolean;
    partiallyProcessed?: boolean;
    accepted?: boolean;
    rejected?: boolean;
    hasAboutSaccosPolicy?: boolean;
    hasMembershipPolicy?: boolean;
    hasCreditProductPolicy?: boolean;
    aboutSaccosPolicyStatus?: string | null;
    membershipPolicyStatus?: string | null;
    creditProductPolicyStatus?: string | null;
}

